var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnchor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#3650A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0063 30C82.3051 30 84.4019 31.3134 85.405 33.3818L109.411 82.8822L109.953 84H96.6163L92.7366 76H67.2759L63.3961 84H50.0594L50.6017 82.8818L74.6077 33.3818C75.6108 31.3134 77.7075 30 80.0063 30ZM72.1256 66H87.887L80.0063 49.7501L72.1256 66ZM97.9995 101H110.005C109.644 117.152 96.2738 130 80.0063 130C63.7388 130 50.3686 117.152 50.0078 101H62.0131C62.2941 108.354 67.1804 114.631 74.0003 116.996V93C74.0003 89.6863 76.6866 87 80.0003 87C83.314 87 86.0003 89.6863 86.0003 93V117C92.8265 114.638 97.7183 108.359 97.9995 101Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchor);
export default __webpack_public_path__ + "static/media/anchor.12f3cdcee30712e971688034f139629f.svg";
export { ForwardRef as ReactComponent };